// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9453fe17","581":"c33f708a","732":"001f964c","977":"dea39d2a"}[chunkId] + ".chunk.js";
};